export enum ShortBreakMode {
  BySchedule = 0,
  ByActivities = 1,
}
